export const GET_ROSTER_NOTES = "GET_ROSTER_NOTES";
export const GET_ROSTER_NOTE_BY_ID = "GET_ROSTER_NOTE_BY_ID";
export const UPDATE_ROSTER_NOTE = "UPDATE_ROSTER_NOTE";
export const DELETE_ROSTER_NOTE = "DELETE_ROSTER_NOTE";
export const CREATE_ROSTER_NOTE = "CREATE_ROSTER_NOTE";
